import getLocalString from "constants/Localization";
import { useGetReportJobsByContactMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportJobsByContact = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportJobsByContactMutation();
  const [getReportJobsByContact, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportJobsByContact",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportJobsByContact, { ...context, data }] as const;
};

export default useGetReportJobsByContact;
